<template>
  <div class='full-details-content'>
    <SellerInformation
      :owners="listing.owners"
      :ownerLicenses="listing.owner_licenses"
      :ownerDesignations="listing.owner_designations"
      :yearsInBusiness="listing.years_in_business"
      :employeesLicensed="listing.team_licensed_employees"
      :employeesUnlicensed="listing.team_unlicensed_employees"
      :employeeLicenses="listing.team_employee_licenses"
      :employeeDesignations="listing.team_employee_designations"
    />

    <CompanyInformation
      :insuranceBasedListings="insuranceBasedListings"
      :practiceType="listing.listing_type"
      :brokerDealer="listing.company_broker_dealer"
      :custodians="listing.company_custodians"
      :tamps="listing.company_tamps"
      :insuranceCarriers="listing.company_insurance_carriers"
      :households="listing.company_households"
      :clientsLocal="listing.company_local_clients"
      :clientTenure="listing.company_average_client_tenture"
      :clientAcquisitionMethods="listing.company_key_method_acquisition"
      :clientAge="listing.company_average_client_age"
      :householdsHighAum="listing.company_households_1m_aum"
      :hasMultigenPlanning="listing.company_multi_gen_plan"
    />

    <RevenueInformation
      :insuranceBasedListings="insuranceBasedListings"
      :listing="listing"
    />

    <ExpenseInformation
      :totalOverhead="listing.expenses_total_overhead"
      :revenuePercent="listing.expenses_percent_of_revenue"
      :employeeCompLicensed="listing.expenses_employee_compensation_licensed"
      :employeeBenefits="listing.expenses_employee_benefits"
      :employeeCompAdmin="listing.expenses_employee_compensation_admin"
      :employeePayrollTaxes="listing.expenses_employee_only_payroll_taxes"
      :employeeComp1099="listing.expenses_contractor_compensation"
      :annualLeaseRent="listing.expenses_annual_lease_rent"
      :advertising="listing.expenses_advertising"
      :brokerDealer="listing.expenses_broker_dealer_fees"
      :dues="listing.expenses_dues"
      :education="listing.expenses_continuing_education"
      :licensing="listing.expenses_licensing_cost"
      :insurance="listing.expenses_insurance"
      :officeSupplies="listing.expenses_office_supplies"
      :entertainment="listing.expenses_entertainment"
      :services="listing.expenses_professional_services"
      :other="listing.expenses_other"
      :maintenance="listing.expenses_maintenance"
      :referrals="listing.expenses_referral_fees"
      :travel="listing.expenses_travel"
      :software="listing.expenses_software_costs"
      :utilities="listing.expenses_utilities"
      :notes="listing.expenses_notes"
    />

    <OtherInformation
      :activeSection="activeSection"
      :insuranceBasedListings="insuranceBasedListings"
      :communicationsList="allListOptions.find(list => list.name == 'communication_methods').list"
      :listing="listing"
      @update:activeSection="$emit('update:activeSection', $event)"
    />

    <BuyerInformation
      :insuranceBasedListings="insuranceBasedListings"
      :practiceType="listing.listing_type"
      :credentials="listing.buyer_credentials"
      :organizations="listing.buyer_organizations"
      :designations="listing.buyer_designations"
      :location="listing.buyer_location"
      :other="listing.buyer_other"
    />

    <AnnualExpensesInformation
      :listing="listing"
    />

    <TermsInformation
      :askingPrice="listing.asking_price"
      :cashDown="listing.cash_down"
      :escrow="listing.escrow"
      :closeDate="listing.anticipated_close_date"
      :consultingTimeline="listing.consulting_timeline"
      :rainmakingClause="listing.rainmaking_clause"
      :postTransition="listing.post_transition"
      :businessDevelopment="listing.business_development"
    />
  </div>
</template>

<script>
import AnnualExpensesInformation from './AnnualExpensesInformation'
import BuyerInformation from './BuyerInformation'
import CompanyInformation from './CompanyInformation'
import ExpenseInformation from './ExpenseInformation'
import OtherInformation from './OtherInformation'
import RevenueInformation from './RevenueInformation'
import SellerInformation from './SellerInformation'
import TermsInformation from './TermsInformation'

export default {
  name: 'FullDetailsContentContainer',
  props: {
    activeSection: String,
    insuranceBasedListings: Array,
    allListOptions: Array,
    listing: {
      type: Object,
      default: () => ({}),
    }
  },
  components: {
    AnnualExpensesInformation,
    BuyerInformation,
    CompanyInformation,
    ExpenseInformation,
    OtherInformation,
    RevenueInformation,
    SellerInformation,
    TermsInformation,
  },

  
}
</script>

<style scoped>

.full-details-content {
  margin-bottom: calc(100vh - 735px);
}

.full-details-content >>> section {
  /* margin: 40px 0; */
  /* padding-top: 96px; */
  padding: 86px 0 0 20px;
}

.full-details-content >>> .info-card {
  margin: 20px 0;
  padding: 20px;

  display: grid;
  grid-template-columns: auto auto auto;
  justify-content: space-around;

  border-style: dashed;
  border-width: 2px;

  background-color: #EFEFEF;
}

.full-details-content >>> section > h2 {
  color: #5F6062;
  font-family: "SansationBold", sans-serif;
  font-size: 22px;
  line-height: 26px;
}

.full-details-content >>> .info-grid {
  margin: 20px 30px;

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 2px;

  background-color: #E6E7E8;
}

.full-details-content >>> .info-item-group {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-rows: auto;
  align-items: center;
  justify-content: flex-start;
  grid-gap: 10px;

  /* background-color: white; */
  background-color: #EFEFEF;
}

/* .full-details-content >>> .info-item-group >>> .empty {
  background-color: #EFEFEF;
} */

.full-details-content >>> .info-grid:not(.list):not(.header) .info-item-group:not(.empty) {
  border-bottom: 2px solid #E6E7E8;
}

.full-details-content >>> .info-grid .info-item-group {
  padding: 20px 10px 20px 40px;
}

.full-details-content >>> .info-card .info-item-group label {
  align-self: flex-end;
}

.full-details-content >>> .info-card .info-item-group span {
  align-self: flex-start;
}

.full-details-content >>> .info-item-group > img,
.full-details-content >>> .info-item-group > .v-icon {
  height: 45px;
  width: 45px;
  color: #97C131;
}

.full-details-content >>> .info-grid.list label,
.full-details-content >>> .info-item-group.list label,
.full-details-content >>> .info-grid:not(.list) .info-item-group:not(.list)  span {
  color: #5F6062;
  font-family: "SansationBold", sans-serif;
  /* font-size: 18px;
  line-height: 22px; */
  font-size: 1.125rem;
  line-height: 1.375rem;
}

.full-details-content >>> .info-grid.list span,
.full-details-content >>> .info-item-group span,
.full-details-content >>> .info-grid:not(.list) .info-item-group:not(.list) label {
  color: #5F6062;
  font-family: "Sansation", sans-serif;
  /* font-size: 16px;
  line-height: 18px; */
  font-size: 1rem;
  line-height: 1.125rem;
}

.full-details-content >>> .info-grid:not(.list) > label.strong,
.full-details-content >>> .info-item-group:not(.list) > label.strong {
  /* font-size: 24px;
  line-height: 28px; */
  font-size: 1.5rem;
  line-height: 1.75rem;
}

.full-details-content >>> .info-item-group.nested {
  margin-left: 30px;
}

.full-details-content >>> .info-item-group.nested > label {
  font-family: "Sansation", sans-serif;
}

.full-details-content >>> .info-grid label.small {
  font-size: 15px;
  line-height: 17px;
}

.full-details-content >>> .info-grid.list {
  grid-gap: 20px 10px;
  /* background-color: white; */
  background-color: #EFEFEF;
}

.full-details-content >>> .info-grid.list .info-item-group {
  padding: 10px;
}

.full-details-content >>> .info-grid.list .info-item-group,
.full-details-content >>> .info-item-group.list {
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  grid-gap: 4px 20px;
  align-items: center;
}

.full-details-content >>> .info-grid.list .info-item-group > img,
.full-details-content >>> .info-grid.list .info-item-group > svg,
.full-details-content >>> .info-item-group.list > img,
.full-details-content >>> .info-item-group.list > svg,
.full-details-content >>> .info-item-group.list > .v-icon {
  grid-row-start: 1;
  grid-row-end: 3;
}

section >>> .v-tabs-bar {
  height: 40px;
  border-bottom: 1px solid #E6E7E8;
}

section >>> .v-tabs-bar__content {
  justify-content: space-around;
}

section >>> .v-tab {
  color: #5F6062;
  font-family: "Sansation", sans-serif;
  font-size: 1rem;
  text-transform: uppercase;
}

section >>> .v-tab--active {
  font-family: "SansationBold", sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/index.vue